export default __webpack_public_path__ + "static/media/visa_jinka.266c4879.png";